<template>
  <p
    class="pb_15 nav__item bg-white"
    v-if="!requestingInfoForFullMonitorSubscription"
  >
    <a
      class="d-flex align-items-center pl-1 py-1 general_border_3 point"
      href="javascript:void(0)"
      role="button"
      @click="$bvModal.show('modal-assistenza')"
      @keydown.enter.prevent="$bvModal.show('modal-assistenza')"
      @keydown.space.prevent="$bvModal.show('modal-assistenza')"
    >
      <b-icon font-scale="1.3" icon="question-circle" aria-hidden="true"></b-icon>
      <span class="mb-0 ml-2">{{$t('SendHelpRequest.titolo')}}</span>
    </a>
    <b-modal
      id="modal-assistenza"
      :title="$t('SendHelpRequest.titoloModale')"
      centered
      hide-footer
      size="lg"
    >
      <p class="px-3 py-2 bg-extra-light general_border text-justify mx-3">
        {{$t('SendHelpRequest.descrizione')}}
      </p>

      <b-form @submit.prevent="submitHelpRequest">
        <b-row>
          <b-col class="col-12">
            <b-form-group :label="$t('SendHelpRequest.oggettoLabel')" label-for="oggetto" class="mb-0">
              <b-form-select
                v-capitalize-first-select
                id="oggetto"
                v-model="form.object"
                :options="objectOptions"
                required
              ></b-form-select>
            </b-form-group>
          </b-col>

          <b-col class="col-12 mt-3">
            <b-form-group :label="$t('SendHelpRequest.messaggioLabel')" label-for="messaggio" class="mb-0">
              <b-form-textarea
                v-capitalize-first
                id="messaggio"
                v-model="form.content"
                rows="5"
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <p class="text-left mt-2 ml-3">{{$t('SendHelpRequest.campiObbligatori')}}</p>
        <b-row class="mt-3">
          <b-col class="col-12 text-right">
            <b-button type="submit" variant="popup-button"
              >{{$t('SendHelpRequest.inviaRichiesta')}}</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </p>
  <b-modal
    v-else
    :id="
      requestingInfoForFullMonitorSubscription
        ? 'modal-assistenza-full-monitor'
        : 'modal-assistenza'
    "
    :title="$t('SendHelpRequest.titoloModale')"
    centered
    hide-footer
    size="lg"
  >
    <b-form @submit.prevent="submitHelpRequest">
      <b-row>
        <b-col class="col-12">
          <b-form-group :label="$t('SendHelpRequest.oggettoLabel')" label-for="oggetto" class="mb-0">
            <b-form-select
              v-capitalize-first-select
              id="oggetto"
              v-model="form.object"
              :options="objectOptions"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>

        <b-col class="col-12 mt-3">
          <b-form-group :label="$t('SendHelpRequest.messaggioLabel')" label-for="messaggio" class="mb-0">
            <b-form-textarea
              v-capitalize-first
              id="messaggio"
              v-model="form.content"
              rows="5"
              required
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <p class="text-left mt-2 ml-3">{{$t('SendHelpRequest.campiObbligatori')}}</p>
      <b-row class="mt-3">
        <b-col class="col-12 text-right">
          <b-button type="submit" variant="popup-button"
            >{{$t('SendHelpRequest.inviaRichiesta')}}</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import { utilityService } from "@/_services";
import { mapActions, mapState } from "vuex";

export default {
  name: "SendHelpRequest",
  computed: {
    ...mapState("company", ["companyLoggedIn", "company"]),
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  props: {
    requestingInfoForFullMonitorSubscription: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // objectOptions: [
      //   {
      //     value: null,
      //     text: this.$t('SendHelpRequest.selezionaOggetto'),
      //   },
      //   {
      //     value: "richiesta informazioni",
      //    text: this.$t('SendHelpRequest.richiestaInformazioni'),
      //   },
      //   {
      //     value: "richiesta implementazione",
      //     text: this.$t('SendHelpRequest.richiestaImplementazione'),
      //   },
      //   {
      //     value: "malfunzionamento",
      //    text: this.$t('SendHelpRequest.malfunzionamento'),
      //   },
      //   {
      //     value: "correzione dati errati",
      //    text: this.$t('SendHelpRequest.correzioneDati'),
      //   },
      //   // {
      //   //   value: "altro",
      //   //   text: "Altro",
      //   // },
      // ],
      form: {
        object: this.requestingInfoForFullMonitorSubscription
          ? this.$t('SendHelpRequest.richiestaInformazioni')
          : null,
        content: this.requestingInfoForFullMonitorSubscription
          ? this.$t('SendHelpRequest.testoRichiestaFullMonitor')
          : null,
      },
    };
  },
  computed: {
    objectOptions() {
        return [
          {
            value: null,
            text: this.$t('SendHelpRequest.selezionaOggetto'),
          },
          {
            value: "richiesta informazioni",
            text: this.$t('SendHelpRequest.richiestaInformazioni'),
          },
          {
            value: "richiesta implementazione",
            text: this.$t('SendHelpRequest.richiestaImplementazione'),
          },
          {
            value: "malfunzionamento",
            text: this.$t('SendHelpRequest.malfunzionamento'),
          },
          {
            value: "correzione dati errati",
            text: this.$t('SendHelpRequest.correzioneDati'),
          },
          // {
          //   value: "altro",
          //   text: this.$t('SendHelpRequest.altro'),
          // },
        ];
      }
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    submitHelpRequest() {
      const self = this;
      utilityService
        .supportRequest(this.form)
        .then((res) => {
          self.successAlert(self.$t('SendHelpRequest.successo'));
          self.form = {
            object: null,
            content: null,
          };
        })
        .catch((err) => {
          self.errorAlert(self.$t('SendHelpRequest.errore'));
        })
        .finally(() => {
          self.$bvModal.hide(
            self.requestingInfoForFullMonitorSubscription
              ? "modal-assistenza-full-monitor"
              : "modal-assistenza"
          );
        });
    },
  },
};
</script>
